import {useNavigate} from 'react-router-dom'
import {KTIcon} from '../../../../../../../_metronic/helpers'
import {useListView} from '../../core/TemplosListViewProvider'
import {useQueryResponse, useQueryResponsePagination} from '../../core/QueryResponseTemplosProvider'
import {getTemples} from '../../core/_requests'

type Props = {
  add_path: string
}

const TemplosListToolbar: React.FC<Props> = ({add_path}) => {
  const navigate = useNavigate()
  const {response, query} = useQueryResponse()
  const pagination = useQueryResponsePagination()

  const {setItemIdForUpdate} = useListView()

  const redirectAdd = () => {
    setItemIdForUpdate(null)
    navigate(add_path)
  }

  const exportToCSV = async () => {
    if (!response?.payload?.pagination?.total || response.payload.pagination.total === 0) {
      alert('Nenhum resultado para exportar. Faça uma busca primeiro.')
      return
    }

    try {
      const totalPages = Math.ceil(
        response.payload.pagination.total / (pagination?.rowsperpage || 10)
      )
      let allTemplos: any[] = []

      // Buscar todas as páginas
      for (let page = 0; page < totalPages; page++) {
        const pageQuery = query.replace(/page=\d+/g, `page=${page}`)
        const pageData = await getTemples(pageQuery)
        if (pageData?.data) {
          allTemplos = [...allTemplos, ...pageData.data]
        }
      }

      if (allTemplos.length === 0) {
        alert('Nenhum resultado para exportar.')
        return
      }

      // Headers do CSV
      const headers = ['ID', 'Cidade', 'Estado', 'UF', 'País', 'Status', 'Ministro', 'Presidente']

      // Dados dos templos
      const rows = allTemplos.map((templo) => [
        templo.id_templo,
        templo.tx_cidade || '',
        templo.tx_estado || '',
        templo.tx_sigla || '',
        templo.tx_pais || '',
        templo.in_templo_ativo === 1 ? 'Ativo' : 'Inativo',
        templo.tx_ministro_presidente || '',
        templo.tx_nome_presidente || '',
      ])

      // Montar CSV
      const csvContent = [
        headers.join(','),
        ...rows.map((row) => row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(',')),
      ].join('\n')

      // Criar blob e download
      const blob = new Blob([csvContent], {type: 'text/csv;charset=utf-8;'})
      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)

      link.setAttribute('href', url)
      link.setAttribute('download', `templos_${new Date().toISOString().split('T')[0]}.csv`)
      link.style.visibility = 'hidden'

      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (error) {
      console.error('Erro ao exportar:', error)
      alert('Erro ao exportar dados. Tente novamente.')
    }
  }

  return (
    <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
      {/* begin::Export */}
      <button type='button' className='btn btn-light-primary me-3' onClick={exportToCSV}>
        <KTIcon iconName='exit-up' className='fs-2' />
        Exportar
      </button>
      {/* end::Export */}

      {/* begin::Add user */}
      <button type='button' className='btn btn-primary' onClick={redirectAdd}>
        <KTIcon iconName='plus' className='fs-2' />
        Novo Cadastro
      </button>
      {/* end::Add user */}
    </div>
  )
}

export {TemplosListToolbar}
